import { Box, Title, Text, Card, Group, Button } from '@mantine/core';
import { useAuth } from '../hooks/useAuth';

export default function Profile() {
  const { user, logout } = useAuth();

  const handleLogout = () => {
    logout();
  };

  return (
    <Box style={{ maxWidth: 800, margin: '0 auto', padding: '2rem' }}>
      <Title mb="xl">Profile</Title>

      <Card shadow="sm" padding="lg" mb="xl">
        <Group position="apart" mb="md">
          <Title order={3}>Account Information</Title>
          <Button variant="light" color="red" onClick={handleLogout}>
            Logout
          </Button>
        </Group>

        <Box mb="md">
          <Text weight={700}>Name</Text>
          <Text>{user?.name}</Text>
        </Box>

        <Box mb="md">
          <Text weight={700}>Email</Text>
          <Text>{user?.email}</Text>
        </Box>

        <Box>
          <Text weight={700}>Account Type</Text>
          <Text>Google Account</Text>
        </Box>
      </Card>

      <Card shadow="sm" padding="lg">
        <Title order={3} mb="md">Preferences</Title>
        
        <Text color="dimmed">
          Preferences and settings will be available in a future update.
        </Text>
      </Card>
    </Box>
  );
}